import axios from "axios";

const baseURL = process.env.REACT_APP_IDP_PROXY_URL ?? 'http://localhost:8080';

export const getProvider = (code) => axios.get(baseURL + "/oauth/provider", {
    params: {
        code
    }
});
